import { ReactNode } from 'react';
import { connect } from 'react-redux';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { setPanelQuoteInfosActiveTab } from 'state/uiPanelState/quoteDetail/quoteDetail.action';
import type { QuoteInfosTab } from 'state/uiPanelState/quoteDetail/quoteDetail.model';
import { getSelectedTab } from 'state/uiPanelState/quoteDetail/quoteDetail.selector';

interface OwnProps {
  tabId: string;

  hasProductDump: boolean;

  detailsContent: ReactNode;

  productDumpContent: ReactNode;
}

interface QuoteDetailDispatchProps {
  selectTabQuoteDetail: (tabId: string) => void;
  selectTabProductDumpDetail: (tabId: string) => void;
}

interface StateProps {
  selectedTabIndex: QuoteInfosTab;
}

export type InfoTabPanelProps = OwnProps & StateProps & QuoteDetailDispatchProps;

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  return {
    selectedTabIndex: getSelectedTab(state, tabId),
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): QuoteDetailDispatchProps => {
  return {
    selectTabQuoteDetail: tabId => {
      dispatch(setPanelQuoteInfosActiveTab(tabId, 'Details'));
    },

    selectTabProductDumpDetail: tabId => {
      dispatch(setPanelQuoteInfosActiveTab(tabId, 'ProductDump'));
    },
  };
};

export const connectInfoTabPanel = connect(mapStateToProps, mapDispatchToProps);
